import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import About from "@/components/site/About";
import Services from "@/components/site/Services";
import WhyChooseUs from "@/components/site/WhyChooseUs";
import Stats from "@/components/site/Stats";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";

export default function Landing() {
  return (
    <div className="relative min-h-screen bg-[#050505] text-white font-body overflow-x-hidden">
      <Navbar />
      <main>
        <Hero />
        <About />
        <Services />
        <WhyChooseUs />
        <Stats />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
